import AMS from "./ams";

function App() {
  return <AMS />;
}

export default App;
